import { getUnit, formatPrice } from "./priceUtils";

export const formatOrderWeight = (orderWeight) => {
	if (orderWeight === 0) {
		return "NVT";
	} else {
		return orderWeight;
	}
};

export const getPublicPrice = (currentProduct) => {
	return (
		formatPrice(currentProduct.salesprice) +
		" / " +
		currentProduct.package_description
	);
};

export const getPricePerProductgroup = (currentProduct) => {
	switch (currentProduct.product_type) {
		case 1:
			return formatPrice(currentProduct.salesprice) + " per stuk";
		case 2:
		case 3:
			if (currentProduct.order_weight === 1000) {
				return formatPrice(currentProduct.salesprice) + " per kilogram";
			}
			var price =
				(currentProduct.order_weight / 1000) * currentProduct.salesprice;
			return (
				formatPrice(price) + " per " + currentProduct.order_weight + " gram"
			);
		default:
			break;
	}
};
export const getPricePerKilo = (currentProduct) => {
	switch (currentProduct.product_type) {
		case 1:
			return;
		case 2:
		case 3:
			if (currentProduct.order_weight != 1000) {
				return (
					" (" +
					formatPrice(currentProduct.salesprice) +
					getUnit(currentProduct.order_weight) +
					")"
				);
			} else {
				break;
			}
		default:
			break;
	}
};

export default formatOrderWeight;
